import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ABOUT_BLOCKS } from "../data/mock";

const AboutSections = () => {
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 space-y-24 md:space-y-32">
        {ABOUT_BLOCKS.map((b, idx) => {
          const isLeft = b.align === "left";
          return (
            <div
              id={b.id}
              key={b.id}
              className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center"
            >
              <div className={`lg:col-span-6 ${isLeft ? "" : "lg:order-2"}`}>
                <div className="relative aspect-[5/4] w-full overflow-hidden rounded-2xl">
                  <img
                    src={b.image}
                    alt={b.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-[1.03]"
                    loading="lazy"
                  />
                </div>
                <div className="mt-4 flex items-center gap-3">
                  <span className="font-serif-display text-[14px] text-[hsl(var(--rc-purple))]">
                    0{idx + 1}
                  </span>
                  <span className="flex-1 h-px bg-[hsl(var(--border))]" />
                  <span className="text-[12px] tracking-[0.2em] uppercase text-[hsl(var(--muted-foreground))]">
                    {b.eyebrow}
                  </span>
                </div>
              </div>

              <div className={`lg:col-span-6 ${isLeft ? "" : "lg:order-1"}`}>
                <p className="text-[12px] tracking-[0.2em] uppercase text-[hsl(var(--rc-purple))] font-medium">
                  {b.eyebrow}
                </p>
                <h3 className="font-serif-display mt-3 text-[34px] md:text-[42px] leading-[1.1] font-semibold text-[hsl(var(--rc-deep))]">
                  {b.title}
                </h3>
                <p className="mt-5 text-[16px] leading-[1.75] text-[hsl(var(--rc-slate))]">
                  {b.body}
                </p>
                <Link
                  to={b.cta.href}
                  className="mt-7 inline-flex items-center gap-2 text-[14px] font-semibold text-[hsl(var(--rc-deep))] hover:text-[hsl(var(--rc-purple))] transition-colors group"
                >
                  {b.cta.label}
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default AboutSections;
